import apiUrl from './api'

class BookletService {
    async SaveBookletDetails(BookletModel) {
       // console.log('tttttt service', BookletModel);
        return apiUrl.post('Booklet/PostBookletForm', BookletModel, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    }
    
}

export default new BookletService();
